import React, { Component } from 'react';
import './../MembershipOverview/MembershipOverview.scss';
import { connect } from 'react-redux';
import { getUserInvitations } from '../../../../../Redux/Actions/EndUser/AccountDetailsActions';
import { updateMemberInvitation } from '../../../../../Redux/Actions/EndUser/MemberInvitationAction';
import { auth } from '../../../../../services';
import {Button} from 'reactstrap';
import swal from 'sweetalert';
import { Link } from 'react-router-dom';

class MembershipNotification extends Component {
	constructor (props){
		super(props);
		this.state = {
            MembershipAssignmentId:0,
            HasAccepted:null,
            MembershipId:0,
            PortalUserID:''
		};
	}

	componentDidMount() {
		//this.props.getUserInvitations(auth.getAuthUserId());
    }
    
    AcceptInvitation = (membershipAssignmentId,membershipId) => {
        this.setState({
            MembershipAssignmentId: membershipAssignmentId,
            HasAccepted :true,
            MembershipId: membershipId,
            PortalUserID : auth.getAuthUserId()
        }, () => {
             this.props.updateMemberInvitation(this.state)
        })
    };

    RejectInvitation = 
        (membershipAssignmentId, membershipId) => {

        this.setState({
            MembershipAssignmentId: membershipAssignmentId,
            HasAccepted :false,
            MembershipId: membershipId,
            PortalUserID : auth.getAuthUserId()
        }, () => {
             this.props.updateMemberInvitation(this.state)
        })
    };

	render() {
		const organizationsDisplay = this.props.userInvitations ? this.props.userInvitations.map((item, i) => {
			return (
                <li className="list-group-item" key={`membership-invitation-${i}`}>
                   <div>
						<span className="dashboard-info-text">{item.organizationName}</span>
						<div className="adjustBtns">
							<button
								className="AcceptRejectBtn btn btn-sm btnPrimary" color="primary"
								size="sm"                                           
								onClick={() => {
									swal({
										title: 'Are you sure?',
										text: `Do you want to Accept the Membership invitation from ${item.organizationName}`,
										icon: 'warning',
										buttons: {
											cancel: 'CANCEL',
											confirm: 'OK'
										},
										dangerMode: true
									}).then((value) => (value ? this.AcceptInvitation(item.membershipAssignmentId, item.membershipId) : null));
								}}
							> 
							Accept
							</button>  
							
							<button
								className="AcceptRejectBtn btn btn-sm btnPrimary" color="primary"
								size="sm"                                           
								onClick={() => {
									swal({
										title: 'Are you sure?',
										text: `Do you want to reject the invitation from ${item.organizationName}`,
										icon: 'warning',
										buttons: {
											cancel: 'CANCEL',
											confirm: 'OK'
										},
										dangerMode: true
									}).then((value) => (value ? this.RejectInvitation(item.membershipAssignmentId, item.membershipId) : null));
								}}
							> 
							Reject
							</button> 
						</div>        
                    </div>
				</li>
			);
		}):"";
		return (
			<div className="my-organization">
				<h3 className="main-title">Membership Invitations</h3>
                <div className ="invitationLabel">
                You have been invited to be part of these Organizations. Please Accept/Reject the Invitation
                </div>
                <div className="card mb-2">
                    <ul className="list-group list-group-flush dashboard-info-list">{organizationsDisplay}</ul>
				</div>
			</div>
		);
	}
}

function mapStateToProps(state) {
    const { user, email, loading } = state.memberInvitation;
    return {
        loading,
        user,
		email,
        userInvitations: state.accountDetails.userInvitations,
    };
}

export default connect(mapStateToProps, { getUserInvitations, updateMemberInvitation })(MembershipNotification);